<template>
  <div class="front-wrapper">
    <header class="main-header">
      <div class="container container-md-lg">
        <div class="header-wrap wrap-lg">
          <div class="header-logo">
            <router-link
              :to="{
                name: 'userdashboard'
              }"
            >
              <img
                :src="logo"
                alt="Logo"
              >
            </router-link>
          </div>
          <div class="header-right lg-wrap">
            <div class="row justify-content-between mx-0">
              <p>
                Client Name:
                <strong>{{ patient.name }}</strong>
              </p>
              <p>
                Email Address:
                <strong>{{ patient.email }}</strong>
              </p>
              <p v-if="patient.physician">
                Physician Name:
                <strong>{{ patient.physician.name }}</strong>
              </p>
            </div>
          </div>
          <div class="header-right-link">
            <router-link
              :to="{
                name: 'PatientView',
                params: {
                  id: patient.id
                }
              }"
            >
              Leave Without Saving
            </router-link>
          </div>
        </div>
      </div>
    </header>

    <div class="container mt-3">
      <Notifications />
    </div>

    <div class="frontend-main">
      <div class="container container-md-lg">
        <h2>Create Order</h2>
        <div class="row">
          <div class="col-md-7">
            <ProductList
              v-if="patient.regimen"
              :open-product-modal="openProductModal"
              :selected-products="selectedProducts"
              :regimen-products="regimenProducts"
              :patient="patient"
              @product-selected="productSelected"
              @physician-selected="handlePhysicianSelected"
              @edit-product-modal="editProductModal"
            />
            <BuildRegimen
              :open-product-modal="openProductModal"
              :selected-products="selectedProducts"
              :patient="patient"
              :show_header=false
              @update:presetselectedProduct="presetAddProduct"
              @update:presetselectedProducts="presetAddProducts"
            />
          </div>
          <div class="col-md-5">
            <h4>Client's Order</h4>
            <p>Add or remove products from client's order</p>
            <div class="wrap-table border-table">
              <div
                v-if="selectedProducts.length == 0"
                class="added-products"
              >
                <p>Please add products</p>
              </div>
              <div
                v-for="product in selectedProducts"
                :key="product.id"
                class="row row-group"
              >
                <div class="col-10 pr-0">
                  <div class="row-large">
                    <div class="col-lg-3">
                      <img
                        v-if="product.image"
                        :src="product.image"
                        class="product-img"
                        alt="Product 1"
                      >
                    </div>
                    <div class="col-lg-9 product-actions">
                      <p class="mb-1">
                        <strong v-html="product.title" />
                      </p>
                      <p class="text-soft mb-1">
                        {{ product.vendor }}
                        <span v-if="product.variant_title && product.variant_title != 'Default Title'">| {{ product.variant_title }}</span>
                        <span class="pl-3">${{ formatMoney(calcProductPrice(product)) }}</span>
                      </p>
                      <p
                        v-if="product.frequency"
                        class="text-soft mb-1"
                      >
                        Frequency:
                        <span class="pl-1">
                          <select
                            id="frequency"
                            v-model="product.selling_plan_id"
                            class="select-md"
                            name="frequency"
                          >
                            <option
                              value=""
                            >
                              One Time
                            </option>
                            <option
                              v-for="(plan, valIdx) in product.frequencyOptions"
                              :key="valIdx"
                              :value="plan.id"
                            >
                              {{ plan.name }}
                            </option>
                          </select>
                        </span>
                      </p>
                      <p
                        :class="!product.changeQty ? 'mb- quanty-action' : 'mb-0 quanty-action d-none'"
                      >
                        <span class="text-soft">Quantity:
                          <span>
                            {{ product.quantity }}
                          </span>
                        </span>
                        <a
                          class="change"
                          href="#"
                          @click.prevent="showChangeQty(product)"
                        >
                          Change
                        </a>
                      </p>
                      <div
                        :class="product.changeQty ? 'wrap-actions' : 'wrap-actions d-none'"
                      >
                        <div class="add-actions">
                          <button
                            id="sub"
                            type="button"
                            class="sub"
                            @click="decreseQty(product)"
                          >
                            -
                          </button>
                          <input
                            v-model="product.newQty"
                            type="text"
                            min="0"
                            max="999"
                          >
                          <button
                            id="add"
                            type="button"
                            class="add"
                            @click="increseQty(product)"
                          >
                            +
                          </button>
                        </div>
                        <a
                          class="update"
                          href="#"
                          @click.prevent="changeQty(product)"
                        >
                          Update
                        </a>
                        <a
                          href="#"
                          @click.prevent="hideChangeQty(product)"
                        >Cancel</a>
                      </div>
                      <p v-if="futureOrder && product.frequencyOptions">
                        <span class="text-soft">Charge Date:
                          <span>{{ product.next_charge_scheduled_at ? formatDate(product.next_charge_scheduled_at) : 'Today' }}</span>
                        </span>
                        <a
                          class="change" 
                          href="#" 
                          @click.prevent="changeScheduleDate(product)"
                        >
                          Change
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-2">
                  <a
                    class="link_action"
                    href="#"
                    @click.prevent="editProductModal(product)"
                  >
                    Edit
                  </a>
                  <br>
                  <a
                    class="link_action"
                    href="#"
                    @click.prevent="removeProduct(product)"
                  >
                    Remove
                  </a>
                </div>
              </div>
              <div class="row py-3 text-right">
                <div class="col-lg-9 col-6">
                  <strong>Tax</strong>
                </div>
                <div class="col-lg-3 col-6">
                  <strong>-</strong>
                </div>
                <div class="col-lg-9 col-6">
                  <strong>Subtotal</strong>
                </div>
                <div class="col-lg-3 col-6">
                  <strong>${{ selectedProducts.length > 0 ? formatMoney(calcSubtotal()) : '0' }}</strong>
                </div>
              </div>
              <div v-if="futureOrder && hasFutureProducts" class="mb-3">
                <h5>Payment Method</h5>

                <div v-if="loadingPaymentMethods">
                  Loading payment methods...
                </div>

                <div v-else-if="paymentMethods.length">

                  <select
                    v-model="selectedPaymentMethodId"
                    class="select-md"
                  >
                    <option
                      v-for="method in paymentMethods"
                      :key="method.id"
                      :value="method.id"
                    >
                      {{ method.card.brand.toUpperCase() }} **** {{ method.card.lastDigits }}
                    </option>
                  </select>
                </div>

                <div class="mt-2">
                  <a href="#" @click.prevent="showAddCard">
                    + Add New Payment Method
                  </a>
                </div>

                <div v-if="showCardForm" class="mt-3">
                  <div class="form-group">
                    <label>Card Number</label>
                    <div id="card-element"></div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <label>Expiry</label>
                      <div id="card-expiry-element"></div>
                    </div>

                    <div class="col-md-6">
                      <label>CVC</label>
                      <div id="card-cvc-element"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="futureOrder && hasFutureProducts" class="mb-3">
                <h5>Shipping Address</h5>

                <div v-if="loadingAddresses">
                  Loading addresses...
                </div>

                <div v-else>
                  <select v-model="selectedAddressOption" class="select-md">
                    <option
                      v-for="addr in shippingAddresses"
                      :key="addr.id"
                      :value="addr"
                    >
                      {{ addr.firstName }} {{ addr.lastName }} -
                      {{ addr.address1 }}, {{ addr.city }}, {{ addr.zip }}
                    </option>

                    <option value="new">+ Add New Address</option>
                  </select>
                </div>

                <!-- Address Form -->
                <div v-if="showAddressForm" class="mt-3">
                  <div class="row">
                    <div class="col-sm-6 form-group">
                      <input
                        v-model="newAddress.first_name"
                        type="text"
                        class="form-control"
                        placeholder="First Name"
                      />
                    </div>

                    <div class="col-sm-6 form-group">
                      <input
                        v-model="newAddress.last_name"
                        type="text"
                        class="form-control"
                        placeholder="Last Name"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 form-group">
                      <input
                        v-model="newAddress.address1"
                        class="form-control"
                        placeholder="Street Address"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 form-group">
                      <input
                        v-model="newAddress.address2"
                        class="form-control"
                        placeholder="Unit or suite number (optional)"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 form-group">
                      <input v-model="newAddress.city" class="form-control" placeholder="City" />
                    </div>

                    <div class="col-md-6 form-group">
                      <StateSelect
                        v-model="newAddress.state"
                        :name="'Shipping state'"
                        placeholder="State"
                        class="select-state"
                        @change="validateNewAddressZip"
                      />
                    </div>

                    <div class="col-md-6 form-group">
                      <input v-model="newAddress.zip"
                        placeholder="ZIP" 
                        :class="shippingZipMessage ? 'form-control error' : 'form-control '"
                        @input="validateNewAddressZip"
                      />

                      <p v-if="shippingZipMessage" class="validation error mt-2">
                        {{ shippingZipMessage }}
                      </p>
                    </div>

                    <div class="col-md-6 form-group">
                      <input v-model="newAddress.country" value="US" class="form-control" placeholder="US" readonly />
                    </div>
                  </div>
                </div>
              </div>

              <div class="pt-1">
                <button
                  v-if="!sending"
                  class="btn btn-primary"
                  @click.prevent="checkout"
                >
                  Checkout
                </button>
                <button
                  v-else
                  class="btn btn-primary"
                  disabled
                >
                  processing...
                </button>
              </div>
              <div class="pt-1">
                <button
                  class="btn btn-primary"
                  @click.prevent="sendUserEmail"
                >
                  SEND SHOPPING CART TO CLIENT
                </button>
              </div>
              <div
                v-if="checkoutError"
                :class="`message warning`"
              >
                <p class="icon">
                  {{ checkoutError }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- /. row-create-account -->
      </div>
    </div>
    <!--/. frontend-main -->
    <Modal
      v-show="isModalVisible"
      :show-modal="showModal"
      :modal-type="'popup-lg'"
      modal-id="add_product"
      @hide-modal-window="showModal = false"
    >
      <ProductModal
        v-show="isModalVisible"
        :key="showModal"
        :product-id="productId"
        :modal-action="modalAction"
        :selected-product="selectedProduct"
        :submit-text="'Add Product To Order'"
        :remove-text="'Remove from Order'"
        :disable-on-out-of-stock="true"
        @remove-product="removeProduct"
        @hide-modal-window="showModal = false"
        @product-selected="productSelected"
      />
    </Modal>

    <Modal
      :show-modal="showOutOfStock"
      :modal-type="'popup-l'"
      modal-id="out_of_stock_products"
      @hide-modal-window="showOutOfStock = false"
    >
      <OutStock
        :key="showOutOfStock"
        :products="outOfStock"
        :text="`Looks like one or more of the products in your client's regimen are temporarily out of stock and not available to order`"
        :title="'Product in Regimen Out of Stock'"
        @hide-modal-window="showOutOfStock = false"
      />
    </Modal>

    <Modal
      :show-modal="showNotAvailable"
      :modal-type="'popup-l'"
      modal-id="no_longer_available_products"
      @hide-modal-window="showNotAvailable = false"
    >
      <OutStock
        :key="showNotAvailable"
        :products="notAvailableStock"
        :text="`Looks like one or more of the products in your client's regimen will no longer be available to order`"
        :title="'Product in Regimen No Longer Available'"
        @hide-modal-window="showNotAvailable = false"
      />
    </Modal>

    <Modal
      v-if="showSheduleOrder"
      :show-modal="showSheduleOrder"
      :modal-type="'popup-l'"
      modal-id="shedule_order"
      @hide-modal-window="showSheduleOrder = false"
    >
      <ScheduleOrder
        :key="showSheduleOrder"
        :product="selectedProduct"
        @add-to-order="addToOrder"
        @hide-modal-window="showSheduleOrder = false"
      />
    </Modal>

    <div
      v-if="(showModal && isModalVisible) || showOutOfStock || showNotAvailable || showSheduleOrder"
      class="modal-backdrop fade show"
    />
  </div>
  <!--/. frontend-wrap -->
</template>

<style scoped>
  #frequency {
    width: calc(100% - 80px);
    display: inline-block;
  }
  .select-state { 
    padding: 4px 10px !important;
  }
</style>

<script>
import logo from '@images/logo-light.png';
import { mapGetters } from 'vuex';
import BuildRegimen from '../partials/BuildRegimen';
import ProductList from '../partials/ProductList';
import Modal from '../partials/Modal';
import ProductModal from '../partials/ProductModal';
import OutStock from './outOfStockProduct';
import ScheduleOrder from '../partials/ScheduleOrder';
import stripe from '@/mixins/stripe';
import patientStateValidation from '@/mixins/patientStateValidation';
import StateSelect from '@/views/components/StateSelect';
import { SEND_CART } from '@/store/patients/actions.types';
import {
  CheckoutService
} from '@/services/api.service';
import {
  formatMoney,
  bulidAddressStr,
  formatMetaModel,
  findMeta,
  getShopifyId
} from '@/helper';
import { ProductService, PatientsService } from '@/services/api.service';
import moment from 'moment';
import axios from 'axios';

// @group Patinet
// Component to create patient orders
export default {
  name: 'PatientCreateOrder',
  components: {
    ProductList,
    BuildRegimen,
    ProductModal,
    Modal,
    OutStock,
    ScheduleOrder,
    StateSelect
  },

  mixins: [patientStateValidation, stripe],

  props: {
    // @vuese
    // Patient object
    patient: {
      type: Object,
      default() {
        return {};
      },
    }
  },

  data() {
    return {
      sending: false,
      logo,
      showModal: false,
      isModalVisible: true,
      productId: null,
      patientId: null,
      physicianId: null,
      selectedProducts: [],
      regimenProducts: [],
      selectedProduct: {},
      modalAction: 'create',
      checkoutError: '',
      showOutOfStock: false,
      outOfStock: [],
      showNotAvailable: false,
      showSheduleOrder: false,
      notAvailableStock: [],
      frequencyOptions: [],
      paymentMethods: [],
      selectedPaymentMethodId: null,
      loadingPaymentMethods: false,
      showCardForm: false,
      shouldCreateToken: false,
      cardError: '',
      stripeInitialized: false,
      shippingAddresses: [],
      selectedShippingAddress: null,
      loadingAddresses: false,
      showAddressForm: false,
      selectedAddressOption: null,
      newAddress: {
        first_name: '',
        last_name: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: ''
      }
    };
  },

  computed: {
    ...mapGetters(['practice', 'currentUser']),
    futureOrder() {
      return Array.isArray(this.practice) ?
        this.patient.practice ? this.patient.practice.future_order : false :
        this.practice.future_order;
    },
    hasFutureProducts() {
      return this.selectedProducts.some(p => p.next_charge_scheduled_at)
    }
  },

  watch: {
    patient: {
      handler: 'fillData',
      immediate: true,
    },
    hasFutureProducts(newVal) {
      if (newVal) {
        this.fetchPaymentMethods();
        this.fetchShippingAddresses();
      } else {
        this.showAddressForm = false;
        this.showCardForm = false;
        this.shouldCreateToken = false;
        this.stripeInitialized = false;
      }
    },
    selectedAddressOption(val) {
      if (val === 'new') {
        this.showAddressForm = true;
        this.selectedShippingAddress = null;

        // reset form
        this.newAddress = {
          first_name: '',
          last_name: '',
          address1: '',
          address2: '',
          city: '',
          state: '',
          zip: '',
          country: ''
        };

      } else {
        this.showAddressForm = false;
        this.selectedShippingAddress = val;
      }
    }
  },
  methods: {
    // @vuese
    // Used to convert address object to string, if object have empty  props
    // return word `None`
    // @arg address object
    bulidAddressStr,

    // @vuese
    // Used to remove product from selected products
    // @arg Product object
    removeProduct(value) {
      this.showModal = false;
      const productIndex = this.findIdx(value);

      if (productIndex !== -1) {
        this.selectedProducts.splice(productIndex, 1);
      }
    },

    // @vuese
    // Used to call function to add product to order or
    // call funtion to pass data to schedule modal,
    // if this feature is enabled
    // @arg Product object
    productSelected(product) {
      this.showModal=false;

      // Don't add product with active subscription to order
      if (product.subscription && product.subscription.status == 'active') return;

      product.newQty = 1;
      product.quantity = 1;
      product.changeQty = false;
      if (!product.selling_plan_id){
        product.selling_plan_id = ''
      }

      if (!product.frequencyOptions) {
        product.frequency = 'One time';
        product.recomendation_type = 'Core Product';
        product.time_of_use = 'Per Package Instructions';
        this.fillMeta(product);
      }

      this.getSellingPlan(product);
      this.addToOrder(product);
      this.checkoutError = null;

      if (this.futureOrder && product.frequencyOptions)
        this.prepareProductForSchedule(product);

    },

    presetAddProduct(product) {
      const matchedProduct = this.selectedProducts
        .findIndex(el => el.shopify_product_graph_id == product.shopify_product_graph_id);

      if (matchedProduct != -1) {
        product.id = this.selectedProducts[matchedProduct].id;
        product.position = this.selectedProducts[matchedProduct].position;
        this.selectedProducts.splice(matchedProduct, 1, product);
      } else {
        // Remove old product id
        delete product.id;
        const postion = this.selectedProducts.length ? this.selectedProducts[this.selectedProducts.length - 1].position + 1 : 0;
        product.position = postion;
        this.selectedProducts.push(product);
      }

      this.getSellingPlan(product);

      if (this.futureOrder) {
        this.prepareProductForSchedule(product);
      }
    },
    presetAddProducts(products) {
      products.forEach(product => {
        const matchedProduct = this.selectedProducts
          .findIndex(el => el.shopify_product_graph_id == product.shopify_product_graph_id);

        if (matchedProduct != -1) {
          product.id = this.selectedProducts[matchedProduct].id;
          product.position = this.selectedProducts[matchedProduct].position;
          this.selectedProducts.splice(matchedProduct, 1, product);
        } else {
          // Remove old product id
          delete product.id;
          const postion = this.selectedProducts.length ? this.selectedProducts[this.selectedProducts.length - 1].position + 1 : 0;
          product.position = postion;
          this.selectedProducts.push(product);
        }

        this.getSellingPlan(product);

        if (this.futureOrder) {
          this.prepareProductForSchedule(product);
        }
      });
    },

    // @vuese
    // Used  to pass data to schedule modal
    // @arg Product object
    prepareProductForSchedule(product) {
      this.showSheduleOrder = false;
      this.selectedProduct = product;
    },

    getSellingPlan(product) {
      ProductService.getSellingPlanByVariant(product.handle)
        .then(resp => {
          
          if(resp.data){
            let sellingPlansData = [];
            if (
              resp.data.data &&
              resp.data.data.product &&
              resp.data.data.product.sellingPlanGroups &&
              resp.data.data.product.sellingPlanGroups.edges.length > 0 &&
              resp.data.data.product.sellingPlanGroups.edges[0].node.sellingPlans
            ) {
              this.frequencyOptions = resp.data.data.product.sellingPlanGroups.edges[0].node.sellingPlans.edges.map(plan => ({
                id: plan.node.id,
                name: plan.node.name
              }));
              this.$set(product, 'frequencyOptions', this.frequencyOptions);
            }
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },

    // @vuese
    // Used to add prouct to order
    // @arg Product object
    addToOrder(product) {
      this.showSheduleOrder = false;
      const productIndex = this.findIdx(product);
      if (productIndex != -1)
        this.selectedProducts.splice(productIndex, 1, product);
      else
        this.selectedProducts.push(product);
    },

    // @vuese
    // Used to change product next change date
    // @arg Product object
    changeScheduleDate(product) {
      this.selectedProduct = product;
      this.showSheduleOrder = true;
    },

    // @vuese
    // Used to to calculate product price, by multiply Product price with
    // product quantity
    // @arg Product object
    calcProductPrice(product) {
      return parseFloat(product.price) * product.quantity;
    },

    // @vuese
    // Calc total price of all products
    calcSubtotal() {
      return this.selectedProducts.reduce((sum, product) => {
        return sum + this.calcProductPrice(product);
      }, 0);
    },

    // @vuese
    // Used format money
    // @arg Price value
    formatMoney (val) {
      return formatMoney(val);
    },


    // @vuese
    // Used to open product modal in create mode and pass product ID to it
    // @arg Product ID
    openProductModal(productId) {
      this.productId = productId;
      this.modalAction = 'create';
      this.selectedProduct = null;
      this.showModal = true;
      this.isModalVisible = false;
    },

    // @vuese
    // Used to open product modal in update mode  and pass product to it
    // @arg Product object
    editProductModal(selectedProduct) {
      this.productId = selectedProduct.shopify_product_graph_id;
      this.selectedProduct = selectedProduct;
      if (selectedProduct.subscription && selectedProduct.subscription.status == 'active') {
        this.selectedProduct.patient = this.patient;
        this.selectedProduct.subscriptionObj = selectedProduct.subscription;
      }
      this.modalAction = 'update';
      this.showModal = true;
      this.isModalVisible = true;
    },

    // @vuese
    // Used to check if there at least one product and if so, redirect to
    // next page
    async checkout() {
      this.checkoutError = null;
      this.sending = true;

      try {
        if (this.selectedProducts.length === 0) {
          this.checkoutError = 'Please add at least one product';
          return;
        }

        if (!this.physicianId) {
          this.checkoutError = 'Please select skincare pro.';
          return;
        }
        
        if (this.shouldCreateToken) {
          await this.createPaymentMethod();

          if (this.cardError) {
            this.sending = false;
            return;
          }

          await this.saveToken(this.patient.id);

          this.selectedPaymentMethodId = "shopifyPaymentMethodId"
        }

        const shippingAddress = this.getFinalShippingAddress();

        if (this.hasFutureProducts && !shippingAddress) {
          this.checkoutError = "Please select or add a shipping address.";
          this.sending = false;
          return;
        }

        if (this.showAddressForm) {
          
          if (!this.newAddress.first_name) {
            this.checkoutError = "Please add first name.";
            return;
          }
          if (!this.newAddress.address1) {
            this.checkoutError = "Please add street address.";
            return;
          }
          if (!this.newAddress.city || !this.newAddress.zip) {
            this.checkoutError = "Please add city.";
            return;
          }
          if (!this.newAddress.zip) {
            this.checkoutError = "Please add zip code.";
            return;
          }
          if (!this.validateNewAddressZip()) {
            this.checkoutError = this.shippingZipMessage || "Invalid ZIP code";
            this.sending = false;
            return;
          }
        }

        if (this.hasFutureProducts && !this.selectedPaymentMethodId) {
          this.checkoutError = "Please add a payment method for this client before creating a future subscription.";
          return;
        }

        const futureProducts = (this.selectedProducts || []).filter(
          item =>
            item.next_charge_scheduled_at &&
            new Date(item.next_charge_scheduled_at) > new Date()
        );

        const normalProducts = (this.selectedProducts || []).filter(
          item =>
            !item.next_charge_scheduled_at ||
            new Date(item.next_charge_scheduled_at) <= new Date()
        );

        if (futureProducts.length > 0) {
          const grouped = {};

          futureProducts.forEach(item => {
            const option = item.frequencyOptions?.find(
              o => o.id === item.selling_plan_id
            );

            const { interval, intervalCount } = this.getPlanDetails(option);

            const date = new Date(item.next_charge_scheduled_at);
            date.setHours(0, 0, 0, 0);

            const epoch = Math.floor(date.getTime() / 1000);

            const key = `${epoch}-${interval}-${intervalCount}`;
            
            const billingPolicy = { interval, intervalCount};
            
            if (!option || !option.name) {
              billingPolicy.maxCycles = 1; // only for fallback case
            }

            if (!grouped[key]) {
              grouped[key] = {
                billingPolicy,
                deliveryPolicy: { interval, intervalCount },
                nextBillingDateEpoch: epoch,
                paymentMethodId: this.selectedPaymentMethodId,
                shippingAddress: shippingAddress,
                lines: []
              };
            }

            grouped[key].lines.push({
              variantShopifyId: Number(item.variant_id),
              quantity: item.quantity
            });
          });

          const loopPayloads = Object.values(grouped);

          const loopResp = await CheckoutService.processLoop(
            { products: loopPayloads },
            this.patient.id,
            this.getRequestPracticeId()
          );
          if (loopResp?.data?.success && normalProducts.length == 0) {
            this.flashSuccess('Subscription is being processed. It may take a few moments.');
            this.$router.push({name: 'PatientView', params: {id: this.patient.id}});
          }
        }

        if (normalProducts.length > 0) {
          let items = normalProducts.map(item => ({
            merchandiseId: item.variant_graph_id,
            quantity: item.quantity,
            sellingPlanId: item.selling_plan_id,
            patientId: this.patient.id,
            userId: this.currentUser.id,
            physicianId: this.physicianId
          }));

          const resp = await ProductService.createCheckoutFor(items);

          if (resp?.data?.data?.cartCreate?.cart) {
            const checkoutResp = await CheckoutService.process(
              {
                web_url: resp.data.data.cartCreate.cart.checkoutUrl
              },
              this.patient.id,
              this.getRequestPracticeId()
            );

            if (checkoutResp.data.url) {
              window.location.href = checkoutResp.data.url;
            } else {
              this.checkoutError = checkoutResp.data.error;
            }
          } else {
            this.checkoutError =
              resp?.data?.data?.cartCreate?.userErrors?.[0]?.message;
          }
        }

      } catch (error) {
        console.error("Checkout error:", error);
        this.checkoutError = "Something went wrong during checkout.";
      } finally {
        this.sending = false;
      }
    },
    
    async fetchPaymentMethods() {
      if (!this.patient?.id) return;
      this.loadingPaymentMethods = true;
      PatientsService.getLoopPaymentMethods(this.patient.id)
        .then(resp => {
          const methods = resp.data['payment_methods'] || [];
          this.paymentMethods = methods;

          if (methods.length > 0) {
            this.selectedPaymentMethodId = methods[0].id;
          }
        })
        .finally(() => {
          this.loadingPaymentMethods = false;
        });
    },

    async fetchShippingAddresses() {
      if (!this.patient?.id) return;

      this.loadingAddresses = true;

      try {
        const resp = await PatientsService.getShippingAddresses(this.patient.id);
        const addresses = resp.data?.addresses || [];
        this.shippingAddresses = addresses;
        if (addresses.length > 0) {
          const defaultAddr = addresses.find(a => a.isDefault) || addresses[0];
          this.selectedAddressOption = defaultAddr;
        }
      } catch (error) {
        console.error("Failed to fetch shipping addresses:", error);
        this.shippingAddresses = [];
        this.selectedShippingAddress = null;
      } finally {
        this.loadingAddresses = false;
      }
    },

    getPlanDetails(option) {
      if (!option || !option.name) {
        return { interval: "DAY", intervalCount: 30 };
      }

      const name = option.name.toLowerCase();

      // interval type
      let interval = "DAY";
      if (name.includes("month")) interval = "MONTH";
      else if (name.includes("year")) interval = "YEAR";
      else if (name.includes("week")) interval = "WEEK";
      else if (name.includes("day")) interval = "DAY";

      // interval count
      const match = name.match(/(\d+)/);
      const intervalCount = match ? Number(match[1]) : 1;

      return { interval, intervalCount };
    },

    showAddCard() {
      if (this.showCardForm) return; // prevent re-init

      this.showCardForm = true;
      this.shouldCreateToken = true;

      this.$nextTick(() => {
        if (!this.stripeInitialized) {
          this.initStripe();
          this.stripeInitialized = true;
        }
      });
    },

    getFinalShippingAddress() {
      if (this.showAddressForm) {
        return {
          firstName: this.newAddress.first_name,
          lastName: this.newAddress.last_name,
          address1: this.newAddress.address1,
          address2: this.newAddress.address2,
          city: this.newAddress.city,
          province: this.newAddress.state,
          country: this.newAddress.country,
          zip: this.newAddress.zip,
          phone: this.newAddress.phone || null
        };
      }

      return this.selectedShippingAddress || null;
    },

    getRequestPracticeId() {
      return this.isRole('super_admin') ? `/${this.patient.practice.id}` : '';
    },

    // @vuese
    // Used to change product quantity
    // @arg Product object
    changeQty(value) {
      const productIndex = this.findIdx(value);
      if (productIndex !== -1) {
        this.selectedProducts[productIndex].changeQty = false;
        if(this.selectedProducts[productIndex].newQty == 0){
          this.selectedProducts.splice(productIndex, 1);
          this.$forceUpdate();
        }else{
          this.selectedProducts[productIndex].quantity = this.selectedProducts[productIndex].newQty;
          this.$forceUpdate();
        }
      }
    },

    // @vuese
    // Used to show product change quantity box
    // @arg Product object
    showChangeQty(value) {
      const productIndex = this.findIdx(value);
      if (productIndex !== -1) {
        this.selectedProducts[productIndex].changeQty = true;
        this.selectedProducts[productIndex].newQty = this.selectedProducts[productIndex].quantity;
        this.$forceUpdate();
      }
    },

    // @vuese
    // Used to hide product change quantity box
    hideChangeQty(value) {
      const productIndex = this.findIdx(value);
      if (productIndex !== -1) {
        this.selectedProducts[productIndex].changeQty = false;
        this.selectedProducts[productIndex].newQty = this.selectedProducts[productIndex].quantity;
        this.$forceUpdate();
      }
    },

    // @vuese
    // Used to decrese product quantity
    // @arg Product object
    decreseQty(value) {
      const productIndex = this.findIdx(value);
      if (productIndex !== -1) {
        if (this.selectedProducts[productIndex].newQty == 0) return;
        this.selectedProducts[productIndex].newQty--;
        this.$forceUpdate();
      }
    },

    // @vuese
    // Used to increse product quantity
    // @arg Product object
    increseQty(value) {
      const productIndex = this.findIdx(value);
      if (productIndex !== -1) {
        this.selectedProducts[productIndex].newQty++;
        this.$forceUpdate();
      }
    },

    // @vuese
    // Used to fine product index in selected products array
    // @arg Product object
    findIdx(value) {
      return this.selectedProducts.findIndex(product => {
        return product.variant_graph_id == value.variant_graph_id;
      });
    },

    // @vuese
    // Used to load additional data to product from shopify
    // @arg Product object
    fillMeta(product) {
      ProductService.getProductMetaByHandle(product.handle)
        .then(resp => {
          if (resp.data.data.productByHandle) {
            product.meta = formatMetaModel(resp.data.data.productByHandle.metafields);
            const usageInstruction = findMeta(product.meta, 'detail', 'usage_instruction');
            if (usageInstruction) product.usage_instruction = usageInstruction.value;

          }
        });
    },

    // @vuese
    // Used to fill local store data
    fillData() {
      this.patientId = this.patient.id;
      if (this.patient.regimen && this.patient.regimen.products.length) {
        this.regimenProducts = this.patient.regimen.products.filter(product => {
          // Remove product if not available
          return product.available ? true : false;
        });

        this.patient.regimen.products.forEach(product => {
          if (!product.hasOwnProperty('qty')) {
            product.quantity = 1;
            product.newQty = 1;
            product.changeQty = false;
          }

          this.fillMeta(product);
          this.getSellingPlan(product);

          if (this.futureOrder) {
            this.prepareProductForSchedule(product);
          }

          // Remove product if not available
          if (product.available == false) {
            this.notAvailableStock.push(product);
            this.removeProduct(product);
          }
          // Show not available if have one
          if (this.notAvailableStock.length)
            this.showNotAvailable = false;

          // Remove product if out of stock
          if (product.in_stock == false) {
            this.outOfStock.push(product);
            this.removeProduct(product);
          }

          // Show out of stock if not showNotAvaliable
          if (this.outOfStock.length && this.showNotAvailable === false)
            this.showOutOfStock = false;
        });
      }
    },

    // @vuese
    // Used to chage format of a date
    // @arg Date value
    formatDate(date) {
      return moment(date).format('YYYY/MM/DD');
    },

    handlePhysicianSelected(id) {
      this.physicianId = id;
      this.checkoutError = null
    },

    validateNewAddressZip() {
      const { valid, message } = this.validateZip(
        this.newAddress.zip,
        this.newAddress.state
      );

      this.shippingZipMessage = message;
      return valid;
    },

    // Used to send cart to patient
    sendUserEmail() {
      if (this.selectedProducts.length == 0) {
        this.checkoutError = 'Please add at least one product';
      } else if (!this.physicianId) {
        this.checkoutError = 'Please select skincare pro.';
      } else {
        let items = this.selectedProducts.map(item => ({
          merchandiseId: item.variant_graph_id,
          quantity: item.quantity,
          sellingPlanId: item.selling_plan_id,
          patientId: this.patient.id,
          userId: this.currentUser.id,
          physicianId: this.physicianId
        }));
        ProductService.createCheckoutFor(items)
          .then(resp => {
            if(resp.data){
              if(resp.data.data.cartCreate.cart){
                this.$store.dispatch(
                  SEND_CART,
                  {
                    id: this.patient.id,
                    practiceId: this.getRequestPracticeId(),
                    url: resp.data.data.cartCreate.cart.checkoutUrl, 
                    physicianId: this.physicianId
                  }
                ).then(
                  resp => {
                    if(resp.status == 204){
                      this.flashSuccess('You’ve emailed your client their cart details. It should arrive in under 5 minutes.');
                    }
                  }
                );
              } else {
                this.checkoutError = resp.data.data.cartCreate.userErrors[0].message;
              } 
            }
          })
          .finally(() => {
            this.sending = false;
          });  
      }
    }
  }
};
</script>
